import { render, staticRenderFns } from "./GoIn.vue?vue&type=template&id=1ba00fb0&scoped=true"
import script from "./GoIn.vue?vue&type=script&lang=js"
export * from "./GoIn.vue?vue&type=script&lang=js"
import style0 from "./GoIn.vue?vue&type=style&index=0&id=1ba00fb0&prod&lang=scss&scoped=true"
import style1 from "./GoIn.vue?vue&type=style&index=1&id=1ba00fb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba00fb0",
  null
  
)

export default component.exports